import { Call } from '@gem/call/CallStore/Call';
import * as callModel from '@gem/call/Model/callModel';
import { CallsServerErrorCode } from '@gem/call/Model/callModel.types';
import { t } from '@gem/modules/i18n';
import { logger } from '@gem/modules/logger';
import { popupsTasks } from '@gem/popups';

import { IStartRecordingData } from './CallRecordingService.types';

export class CallRecordingService {
  call: Call;

  constructor(params: { call: Call }) {
    this.call = params.call;
  }

  async startRecording({ recordingType, title }: IStartRecordingData): Promise<void> {
    const channelId = this.call.channelId;
    if (!channelId) {
      return;
    }
    try {
      logger.get('API').debug('calls.startRecording', { recordingType, title });

      await callModel.startRecording({
        channelId,
        recordingType,
        title,
      });
    } catch (e) {
      logger.get('API').error('calls.startRecording', e);

      if (e.message === CallsServerErrorCode.RecordingIsStartedAlready) {
        popupsTasks.showAlert(t('call_record_started_already_message'));
        return;
      }

      if (e.message === CallsServerErrorCode.NoPermissionsToRecordACall) {
        popupsTasks.showAlert(t('call_record_no_permissions_to_start_message'));
        return;
      }

      if (e.message === CallsServerErrorCode.ChannelClosed) {
        popupsTasks.showAlert(t('call_record_completed_call_message'));
        return;
      }

      popupsTasks.showAlert(t('common_somethings_wrong_error'));
    }
  }

  async stopRecording(): Promise<void> {
    try {
      const channelId = this.call.channelId;
      const recordingId = this.call.recordingId;

      if (!channelId) {
        return;
      }

      if (!recordingId) {
        popupsTasks.showAlert(t('call_record_can_not_be_stopped_message'));
        return;
      }

      logger.get('API').debug('calls.stopRecording', { channelId, recordingId });

      await callModel.stopRecording({
        channelId,
        recordingId,
      });
    } catch (e) {
      popupsTasks.showAlert(t('call_record_can_not_be_stopped_message'));
    }
  }
}
